import { Modal, ModalHeader, ModalBody, ModalFooter } from '@/components/ui/Modal';

interface DeleteConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isDeleting: boolean;
  entityName: string;
  itemName: string;
}

export function DeleteConfirmModal({ isOpen, onClose, onConfirm, isDeleting, entityName, itemName }: DeleteConfirmModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size="sm">
      <ModalHeader onClose={onClose}>Delete {entityName}</ModalHeader>
      <ModalBody>
        <p className="text-sm text-gray-600">
          Are you sure you want to delete <strong>{itemName}</strong>? This change will be synced to all POS terminals.
        </p>
      </ModalBody>
      <ModalFooter>
        <button type="button" onClick={onClose} className="btn btn-outline" disabled={isDeleting}>
          Cancel
        </button>
        <button type="button" onClick={onConfirm}
          className="btn bg-red-600 text-white hover:bg-red-700" disabled={isDeleting}>
          {isDeleting ? 'Deleting...' : 'Delete'}
        </button>
      </ModalFooter>
    </Modal>
  );
}
